import { withPermissions } from "../../../layout/Permissions";
import { PERMISSION_USER } from "../../user/constants/permissions";
import CalculsParameters from "../containers/CalculsParameters";

const CalculsParametersPage = () => {
  return <CalculsParameters />;
};
export default withPermissions(CalculsParametersPage, PERMISSION_USER);
